import { Calculator, Briefcase, LineChart, Settings, LogIn, LogOut } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSession, useAuth } from '@/contexts/AuthContext';

export function BottomTabBar(): React.JSX.Element {
  const location = useLocation();
  const { user } = useSession();
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const isActive = (path: string): boolean => {
    return location.pathname === path;
  };

  const handleSignOut = async (): Promise<void> => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Failed to sign out:', error);
      // Navigate anyway to ensure user doesn't get stuck
      navigate('/');
    }
  };

  const tabs = user
    ? [
        { path: '/calculator', label: 'Calculator', icon: Calculator },
        { path: '/contractor', label: 'Contractor', icon: Briefcase },
        { path: '/tracker', label: 'Tracker', icon: LineChart },
        { path: '/settings', label: 'Settings', icon: Settings },
        { action: handleSignOut, label: 'Sign Out', icon: LogOut },
      ]
    : [
        { path: '/calculator', label: 'Calculator', icon: Calculator },
        { path: '/contractor', label: 'Contractor', icon: Briefcase },
        { path: '/tracker', label: 'Tracker', icon: LineChart },
        { path: '/login', label: 'Login', icon: LogIn },
      ];

  const gridColsClass = user ? 'grid-cols-5' : 'grid-cols-4';

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className={`grid ${gridColsClass} h-16`}>
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const key = 'path' in tab ? tab.path : tab.label;

          if ('action' in tab) {
            return (
              <button
                key={key}
                onClick={tab.action}
                className="flex flex-col items-center justify-center gap-1 transition-colors text-gray-600 hover:text-primary"
              >
                <Icon className="w-5 h-5 stroke-2" />
                <span className="text-xs">{tab.label}</span>
              </button>
            );
          }

          const active = isActive(tab.path);
          return (
            <Link
              key={key}
              to={tab.path}
              className={`flex flex-col items-center justify-center gap-1 transition-colors ${
                active
                  ? 'text-primary font-semibold'
                  : 'text-gray-600 hover:text-primary'
              }`}
            >
              <Icon className={`w-5 h-5 ${active ? 'stroke-[2.5]' : 'stroke-2'}`} />
              <span className="text-xs">{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
